export enum LoginTypes {
    LOGIN_REQUEST = '@auth/LOGIN_REQUEST',
    LOGIN_SUCCESS = '@auth/LOGIN_SUCCESS',
    LOGIN_FAILURE = '@auth/LOGIN_FAILURE',
}

export enum RegisterTypes {
    REGISTER_REQUEST = '@auth/REGISTER_REQUEST',
    REGISTER_SUCCESS = '@auth/REGISTER_SUCCESS',
    REGISTER_FAILURE = '@auth/REGISTER_FAILURE',
}

export enum UserCerqTypes {
    SUCCESS_USER_OPT_IN = '@auth/SUCCESS_USER_OPT_IN',
    FAILURE_USER_OPT_IN = '@auth/FAILURE_USER_OPT_IN',
}

export enum LoginSave {
    PERSIST_REHYDRATE = 'persist/REHYDRATE',
}

export enum RefreshTokenTypes {
    REFRESH_TOKEN = '@auth/REFRESH_TOKEN',
}

export enum AgendaTypes {
    AGENDA_REQUEST_SUCCESS = '@auth/AGENDA_REQUEST_SUCCESS',
    AGENDA_REQUEST_FAILURE = '@auth/AGENDA_REQUEST_FAILURE',
    AGENDA_RESPONSE = '@auth/AGENDA_RESPONSE',
}

export interface AgendaInterface {
    solicitouAgendaHoje: boolean
}

export interface RefreshTokenInterface {
    refreshToken: string
    token: string
}

export interface InstitutionLogin {
    email: string
    password: string
}

export interface InstitutionRegister {
    fantasy_name: string
    type: string
    cnpj_cpf: string
    zipcode: string
    address: string
    number: string
    complement: string
    district: string
    city: string
    state: string
    fone: string
    email: string
    // login: string
    password: string
}

export type ResponseLoginSuccess = {
    token: string
    user: User
}

export interface User {
    // username: string
    email: string
    empresa: string
    verificationC: boolean
    isDocumentValid: boolean
    cnpj_cpf: string
    solicitouAgendaHoje: boolean
}

export interface AuthState {
    isLoggedIn: boolean
    user: User
    token: string
    refreshToken: string
    registerError: boolean
    isLoading: boolean
}
